import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className='app__bg app__wrapper section__padding'>
    <div className='app__wrapper_img app__wrapper_img-reverse'>
      <img src={images.chef} alt='Chef in Action' />
    </div>
    <div className='app__wrapper_info'>
      <SubHeading title='A Message from the Chef' />
      <h1 className='headtext__cormorant'>Our Culinary Philosophy</h1>

      <div className='app__chef-content'>
        <div className='app__chef-content_quote'>
          <img src={images.quote} alt='Quote Icon' />
          <p className='p__opensans'>
            Cooking is an art, but all art requires knowing something about the
            techniques.
          </p>
        </div>
        <p className='p__opensans'>
          At the heart of our restaurant is a passion for creating extraordinary
          culinary experiences. Every dish is crafted with care, using the
          finest ingredients and time-honored techniques. We believe in blending
          creativity with tradition to delight every palate.
        </p>
      </div>

      <div className='app__chef-sign'>
        <p>Kevin Luo</p>
        <p className='p__opensans'>Chef & Founder</p>
        <img src={images.sign} alt='Chef Signature' />
      </div>
    </div>
  </div>
);

export default Chef;
